import { Retool } from '@tryretool/custom-component-support'

export const useSomeHook = () => {
  return Retool.useStateObject({
    name: 'hookState',
    initialValue: {
      something: 2,
      sometOtherThing: [1, 2, 3, 5.6],
    },
    description: 'blah',
    label: 'hook state',
    inspector: 'text',
  })
}
